// extracted by mini-css-extract-plugin
export default {"tooltip":"_5D2yCs-y","is-aligned-left":"_5D3zTApU","is-aligned-center":"_5D2E4ZOR","is-aligned-right":"_5D2tcmfi","tooltip__wrapper":"_5D7eMF3N","is-visible":"_5D-lOnpS"};